<template>
    <div>

        <div class="row">
            <div class="col-md-6 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Estimated Manual Effort</div>
                    <div class="panel-body">

                        <div style="font-size: 40px;">{{ manualEffort}} hours</div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

    export default {
        data() {
            return {
                percentage_delete: null,
                percentage_auto: null,
                percentage_manual: null,
                percentage_rewrite: null,
                processed_asset_count: 0,
            }
        },
        computed: {
            manualEffort: function() {
                // Adding commas: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
                return (Math.round((this.percentage_manual / 100 * 0.25 + this.percentage_rewrite / 100 * 4) * this.processed_asset_count)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
        mounted() {
            axios.get('/api/free_counts')
                .then(response => {
                    console.log('this is the data we get from /api/get_counts in work component')
                    console.log(response.data)
                    const count = response.data.find((count) => {
                        return count.count_type ===  'processed_asset_count';
                    });

                    this.processed_asset_count = count.count
                })
                .catch(error => {
                    console.log('oops getting the counts')
                })
            axios.get('/api/free_percentages')
                .then(({ data}) => {
                    this.percentage_delete = data.find((x) => x.slug === 'drop-and-forget').percentage;
                    this.percentage_auto = data.find((x) => x.slug === 'move-as-is-auto').percentage;
                    this.percentage_manual = data.find((x) => x.slug === 'move-as-is-manual').percentage;
                    this.percentage_rewrite = data.find((x) => x.slug === 'rewrite-one-for-one').percentage;
                    console.log(data)
                })
                .catch(error => {
                    console.log('oops getting field summary')
                })
        }
    }

</script>